<template>
    <router-view />
</template>

<script>
import store from './store/index';

export default {
    name: 'App',
    store,
};
</script>

<style lang="scss">
    /* Import Font Awesome Icons Set */
    $fa-font-path: '@fortawesome/fontawesome-pro/webfonts';
    @import '@fortawesome/fontawesome-pro/scss/fontawesome.scss';
    @import '@fortawesome/fontawesome-pro/scss/solid.scss';

    // Import Main styles for this application
    @import 'assets/scss/style.scss';

    // Inserve Theming options
    :root {
        --main-color: #EA985C;
        --color-main-darken: hsl(from var(--main-color) h s calc(l - 10));
        --color-main-lighten: hsl(from var(--main-color) h s calc(l + 20));
        --secondary-color: #2ecc71;
        --link-color: #2ecc71;
        --link-color-darken: hsl(from var(--link-color) h s calc(l - 10));
        --text-color: #FFFFFF;
    }

    // TEXT
    .text-primary {
        color: var(--main-color) !important;
    }

    // BUTTONS
    .btn-primary {
        background-color: var(--main-color) !important;
        border-color: var(--main-color) !important;
        color: var(--text-color) !important;

        &:hover {
            background-color: var(--color-main-darken) !important;
            border-color: var(--color-main-darken) !important;
        }

        &:focus, &:active {
            -webkit-box-shadow: 0 0 0 0.2rem var(--color-main-lighten);
            box-shadow: 0 0 0 0.2rem var(--color-main-lighten);
        }

        &:not(:disabled):not(.disabled):active:focus,
        &:not(:disabled):not(.disabled).active:focus,
        .show > &.dropdown-toggle:focus {
            -webkit-box-shadow: 0 0 0 0.2rem var(--color-main-lighten);
            box-shadow: 0 0 0 0.2rem var(--color-main-lighten);
        }
    }

    .btn-outline-primary {
        color: var(--main-color) !important;
        border-color: var(--main-color) !important;

        &:hover {
            background-color: var(--color-main-darken) !important;
            color: white !important;
        }

        &:focus, &:active {
            -webkit-box-shadow: 0 0 0 0.2rem var(--color-main-lighten);
            box-shadow: 0 0 0 0.2rem var(--color-main-lighten);
        }

        &:not(:disabled):not(.disabled):active {
            background-color: var(--main-color);
        }

        &:not(:disabled):not(.disabled):active:focus,
        &:not(:disabled):not(.disabled).active:focus,
        .show > &.dropdown-toggle:focus {
            -webkit-box-shadow: 0 0 0 0.2rem var(--color-main-lighten);
            box-shadow: 0 0 0 0.2rem var(--color-main-lighten);
        }
    }

    .object-actions i.object-actions-icons:hover {
        color: var(--main-color) !important;
    }

    .object-actions .object-actions-item > a:hover {
        color: var(--main-color) !important;
    }

    .btn-outline-primary:not(:disabled):not(.disabled).active {
        background-color: var(--main-color) !important;
        color: var(--text-color) !important;
    }

    .b-nav-dropdown {
        .avatar-badge {
            cursor: pointer;
        }
    }

    .show > .btn-outline-primary.dropdown-toggle {
        background-color: var(--main-color) !important;
        color: var(--text-color) !important;
    }

    // A
    a {
        &:hover {
            color: var(--link-color-darken) !important;

            &.dropdown-item i {
                color: var(--link-color) !important;
            }
        }
    }

    .v-sidebar-menu {
        a {
            &:hover {
                color: inherit !important;

                &.dropdown-item i {
                    color: inherit !important;
                }
            }
        }
    }

    .dropdown-toggle-no-caret.btn:hover {
        color: var(--link-color) !important;
    }

    // AVATAR
    .avatar-badge {
        background-color: var(--main-color) !important;
    }

    // SIDEBAR
    .sidebar .nav-link {
        &.active {
            color: var(--text-color) !important;
            background: var(--main-color) !important;
        }

        &:hover {
            color: #fff !important;
            background: var(--main-color) !important;
        }
    }

    .tab-menu-container .active-border-menu {
        background: var(--main-color) !important;
    }

    @media (min-width: 992px) {
        .sidebar-minimized .sidebar .nav-item:hover > .nav-link {
            background: var(--main-color) !important;
        }
    }

    // PAGINATION
    .dark body .page-item.active .page-link {
        background-color: var(--main-color) !important;
    }

    .page-item.active .page-link {
        background-color: var(--main-color) !important;
        border-color: var(--main-color) !important;
        color: white !important;
    }

    .page-link {
        color: var(--main-color) !important;
    }

    // NAVIGATION
    .nav-pills .nav-link.active, .nav-pills .show > .nav-link {
        background-color: var(--main-color) !important;
        color: var(--text-color) !important;
    }

    .dropdown-item.active, .dropdown-item:active {
        background-color: var(--main-color) !important;
        i {
            color: var(--text-color) !important;
        }

        &:hover {
            i {
                color: var(--text-color) !important;
            }

            color: var(--text-color) !important;
        }
    }

    //CHECKBOX
    .custom-control-input:checked ~ .custom-control-label::before {
        color: var(--text-color) !important;
        border-color: var(--main-color) !important;
        background-color: var(--main-color) !important;
    }

    //INPUT
    .form-control:focus {
        border-color: var(--color-main-lighten) !important;
    }

    //Badge
    .alert-primary, .badge-primary {
        background-color: var(--main-color) !important;
        border-color: var(--main-color) !important;
        color: var(--text-color) !important;
    }

    // Toast
    .toasted.bubble {
        display: flex;
        align-items: baseline;
        font-weight: 600;

        &.success {
            color: $text-success;
            background: $success !important;

            .toast-close {
                color: $text-success;
                font-weight: 600;
            }
        }

        &.error {
            color: $text-danger;
            background: $danger !important;

            .toast-close {
                color: $text-danger;
                font-weight: 600;
            }
        }

        &.info {
            color: $text-info;
            background: $info !important;

            .toast-close {
                color: $text-info;
                font-weight: 600;
            }

            .action {
                color: $text-info;
            }
        }
    }

    // Loaders
    .bg-primary {
        background-color: var(--main-color) !important;
    }

    // Sidebar
    .v-sidebar-menu {
        --vsm-primary-color: var(--main-color);
        --vsm-item-active-line-color: var(--vsm-primary-color);
        --vsm-item-open-bg: var(--vsm-primary-color);
        --vsm-mobile-item-bg: var(--vsm-primary-color);
    }
</style>
